import { User } from '@models/user.model';
import { Role } from '@models/role.model';

export class UserStudy {
  constructor() {
    this.user = new User();
  }
  userStudyId: number;
  userId: number;
  studyId: number;
  roleId?: number;
  isActive: boolean;
  createdBy: number;
  createdDate: Date;
  updatedBy: number;
  updatedOn: Date;

  user: User;
  role: Role;

  // required on UI side to keep track of adding and removing users dynamically.
  rowId: number;
}
